<template>
  <div id="EC-Site" v-cloak>
    <component :template="template" :is="template"></component>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'EC-Site',
  data: function() {
    return {
      template: localStorage.template ? localStorage.template : '',
    }
  },
  components: {
    login: () => import('./components/Login'),
    template2: () => import('./templates/template2/index.vue'),
    notfound: () => import('components/404'),
  },
  mounted: function() {
    var _this = this;
    _this.template = 'template2';
  },
}
</script>
<style>
.modal-header h5{
  margin: 0 15px !important;
  font-size: 1.25rem !important;
}
.modal-body{
  margin: 0 15px !important;
}
.modal-body .text-danger {
  font-size: 1rem !important;
}
.modal-body .container-fluid b,.modal-body .container-fluid img{
  vertical-align: baseline !important;
  font-size: initial !important;
}
.modal-body .container-fluid h1{
  font-size: large !important;
}
</style>
